module.exports = __webpack_public_path__ + "img/badge_rimborso_bollette.4fe170cc.jpg";